import { Box, Button, Dialog, Theme, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import OTPForm from "../../lib/formik/OtpForm";
import { SuccessIcon } from "../../assets/SvgIcons";
import { nomineeOptOutResendOtp, nomineeOptOutVerifyOtp } from "../../redux-store/actions/application";
import { ApplicationProps, NomineeOptOutVerifyOtpResponseBody } from "../../redux-store/types/api-types";
import { showError } from "../../redux-store/actions/auth";
import { INVESTOR_NOMINEE_OPT_OUT_TOKEN } from "../../redux-store/types/auth";


interface RouterParamsData {
    message: string;
    otpRecordId: number;
    token: string;
    applicationId: number;
}

export default function GetAndVerifyPaymentOtp(): JSX.Element {
    const history = useHistory();

    const dispatch = useDispatch();

    const routerParamsData = history.location.state as unknown as RouterParamsData

    const [isOtpSuccessDialogOpen, setIsOtpSuccessDialogOpen] = useState<boolean>(false);
    const [verifyOtpSuccessData, setVerifyOtpSuccessData] = useState<NomineeOptOutVerifyOtpResponseBody | null>(null)

    const handleNomineeOptOutOtpSubmit = async (otp: string) => {
        const payload = {
            id: Number(routerParamsData?.otpRecordId ?? ""), //otpRecordId
            token: routerParamsData?.token ?? "", //token
            otp,
            applicationId: Number(routerParamsData?.applicationId ?? "") //applicationId
        }

        const response = await dispatch(nomineeOptOutVerifyOtp(payload)) as unknown as NomineeOptOutVerifyOtpResponseBody;

        if (!response) {
            return
        }

        if (!response?.isSuccess) {
            dispatch(showError(response?.message ?? ""))
            return
        }

        if (response?.isSuccess) {
            setVerifyOtpSuccessData(response)
            setIsOtpSuccessDialogOpen(true)
            return
        }
    }

    const handleNomineeOptOutOtpResend = async () => {
        const payload = {
            id: Number(routerParamsData?.otpRecordId ?? ""), //otpRecordId
            token: routerParamsData?.token ?? "", //token
            applicationId: Number(routerParamsData?.applicationId ?? "") //applicationId
        }

        const response = await dispatch(nomineeOptOutResendOtp(payload)) as unknown as ApplicationProps;

        history.replace({
            pathname: history.location.pathname,
            state: {
                message: response?.message,
                otpRecordId: response?.otpRecordId,
                token: response?.token,
                applicationId: response?.applicationId
            }  //updating router status if resend otp is success
        });
    }

    const handleGoToApplicationPreview = () => {
        dispatch({
            type: INVESTOR_NOMINEE_OPT_OUT_TOKEN,
            body: {
                token: verifyOtpSuccessData?.application?.authorizationToken ?? ""
            }
        })

        history.replace('application-preview', {
            applicationData: verifyOtpSuccessData?.application
        });
    }

    return (
        <>
            <Box sx={{ padding: '30px 45px' }}>
                <Box sx={(theme: Theme) => ({ borderBottom: `0.5px solid ${theme.palette.customColors.pastelGrey}` })}>
                    <Typography
                        variant="h1"
                        sx={(theme: Theme) => ({
                            lineHeight: "32.5px",
                            color: theme.palette.text.primary,
                            mb: 1,
                            textAlign: "center"
                        })}
                    >
                        Nominee Opt Out Authentication
                    </Typography>
                </Box>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: "50px",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    })}
                >
                    <Box sx={{ minWidth: "350px", maxWidth: "500px" }}>
                        <OTPForm
                            onSubmit={handleNomineeOptOutOtpSubmit}
                            onResend={handleNomineeOptOutOtpResend}
                            otpMessage={routerParamsData?.message ?? ''}
                            warningMessage=""
                        />
                    </Box>
                </Box>
            </Box>
            <Dialog
                open={isOtpSuccessDialogOpen}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "30px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Success!
                        </Typography>
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {verifyOtpSuccessData?.message ?? ""}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                borderRadius: "10px",
                                padding: { xs: "10px 20px", md: "13px 20px" },
                                backgroundColor: theme.palette.primary[500],
                                lineHeight: "20px"
                            })}
                            onClick={handleGoToApplicationPreview}
                        >
                            Go To Application Preview
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}
